const broadcastRates = [
  ["23.976", 24000, 1001],
  ["29.97", 30000, 1001],
  ["59.94", 60000, 1001],
  ["119.88", 120000, 1001],
];

function gcd(a, b) {
  while (b) [a, b] = [b, a % b];
  return a;
}

export function frameRateFraction(value) {
  const input = String(value ?? "").trim();
  if (!/^\d+(?:\.\d{1,6})?$/.test(input)) return null;
  const matchingRate = broadcastRates.find(([label]) => Number(input) === Number(label));
  if (matchingRate) return { numerator: matchingRate[1], denominator: matchingRate[2] };
  const [whole, decimals = ""] = input.split(".");
  const denominator = 10 ** decimals.length;
  const numerator = Number(`${whole}${decimals}`);
  if (!Number.isSafeInteger(numerator) || numerator <= 0) return null;
  const divisor = gcd(numerator, denominator);
  return { numerator: numerator / divisor, denominator: denominator / divisor };
}

export function frameRateText(numerator, denominator) {
  if (!/^\d+$/.test(String(numerator)) || !/^\d+$/.test(String(denominator)) || Number(denominator) === 0)
    return String(numerator ?? "");
  const num = Number(numerator);
  const den = Number(denominator);
  const matchingRate = broadcastRates.find(([, n, d]) => num * d === n * den);
  if (matchingRate) return matchingRate[0];
  return String(Number((num / den).toFixed(6)));
}

export function frameRateError(label, value, { min = 1, max = 240 } = {}) {
  const fraction = frameRateFraction(value);
  if (!fraction || fraction.numerator > 2147483647 || fraction.denominator > 2147483647)
    return `${label} must be a number from ${min} to ${max} fps (up to 6 decimal places)`;
  const fps = fraction.numerator / fraction.denominator;
  if (fps < min || fps > max) return `${label} must be from ${min} to ${max} fps`;
  return "";
}
